import { Box } from "@mui/material"

const Layout = (props) => {
  const { children } = props

  return (
    <Box
      sx={{
        backgroundColor: "bg.light",
        display: "flex",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          width: "90%",
          maxWidth: "450px",
          py: 2,
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default Layout
